import { render, staticRenderFns } from "./EditBlogPost.vue?vue&type=template&id=706febcd&scoped=true"
import script from "./EditBlogPost.vue?vue&type=script&lang=js"
export * from "./EditBlogPost.vue?vue&type=script&lang=js"
import style0 from "./EditBlogPost.vue?vue&type=style&index=0&id=706febcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706febcd",
  null
  
)

export default component.exports